import { withSvgIcon } from './withSvgIcon';

export const MobileIcon = withSvgIcon(
  <>
    <path d="M7.72003 17H12.28C13.419 17 13.9885 17 14.422 16.7748C14.7873 16.5851 15.0851 16.2872 15.2749 15.9219C15.5 15.4885 15.5 14.919 15.5 13.78V6.22C15.5 5.08102 15.5 4.51153 15.2749 4.07805C15.0851 3.71276 14.7873 3.41492 14.422 3.22517C13.9885 3 13.419 3 12.28 3H7.72003C6.58105 3 6.01156 3 5.57808 3.22517C5.2128 3.41492 4.91495 3.71276 4.7252 4.07805C4.50003 4.51153 4.50003 5.08102 4.50003 6.22V13.78C4.50003 14.919 4.50003 15.4885 4.7252 15.9219C4.91495 16.2872 5.2128 16.5851 5.57808 16.7748C6.01156 17 6.58105 17 7.72003 17Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
    <circle cx="10" cy="14" r="1" fill="currentColor" />
  </>,
  { viewBox: '0 0 20 20' },
);
